import { useTranslation } from "react-i18next";
import { Check, X } from "lucide-react";

const INCLUDED = ["Comprehensive insurance with CDW", "Third-party cover over 1 million USD", "Unlimited UAE kilometres on daily and weekly rentals", "3,000 km/month on monthly rentals (4,000 km +12% · 5,000 km +22%)", "Routine maintenance and servicing", "24/7 roadside assistance", "Free replacement on genuine breakdown", "VAT shown in every displayed price"];
const NOT_INCLUDED = ["Tolls (Salik in Dubai, Darb in Abu Dhabi), +25% admin fee", "Fuel, return at handover level or cost +15%", "Traffic fines (+10% admin fee)", "Excess kilometres (AED 0.50–0.75/km + VAT)", "Airport surcharge where applicable (AED 52.50 incl. VAT)", "Optional extras (child seats, additional drivers)"];

export const IncludedTable = () => {
  const { t } = useTranslation();
  return (
    <div className="grid sm:grid-cols-2 gap-4" data-testid="included-table">
      <div className="bg-white border border-[#e2ebe4] rounded-2xl p-5">
        <h3 className="heading-upper text-sm tracking-widest text-[#144733] mb-3">{t("What's included")}</h3>
        <ul className="space-y-2">
          {INCLUDED.map((item) => (
            <li key={item} className="flex gap-2 text-xs text-[#41504a]"><Check className="w-4 h-4 text-[#009900] shrink-0" />{t(item)}</li>
          ))}
        </ul>
      </div>
      <div className="bg-white border border-[#e2ebe4] rounded-2xl p-5">
        <h3 className="heading-upper text-sm tracking-widest text-[#144733] mb-3">{t("Not included")}</h3>
        <ul className="space-y-2">
          {NOT_INCLUDED.map((item) => (
            <li key={item} className="flex gap-2 text-xs text-[#41504a]"><X className="w-4 h-4 text-[#b91c1c] shrink-0" />{t(item)}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};
